import React from 'react';
import { useT } from '../../contexts/LocaleContext.jsx';
import { richMessage } from '../../_helpers/richMessage.jsx';

/**
 * Step-by-step setup for sending a show to SongShake as a second destination
 * next to YouTube/Twitch (ENG-763): OBS's multiple RTMP outputs, and a
 * Restream custom RTMP destination. With the band's `ingestUrl` the steps name
 * it; the key appears only when `revealed`, so it is never on screen unasked.
 */
function MultistreamInstructions({ ingestUrl = null, streamKey = null, revealed = false }) {
  const t = useT();
  const server = ingestUrl || t('multistream.instructions.yourServer');
  const key = streamKey && revealed ? streamKey : t('multistream.instructions.yourKey');
  const parts = { server: <code>{server}</code>, key: <code>{key}</code> };
  const steps = (prefix, count) =>
    Array.from({ length: count }, (_, i) => (
      <li key={i}>{richMessage(t(`multistream.instructions.${prefix}.step${i + 1}`), parts)}</li>
    ));

  return (
    <section
      id="songshake-feed-instructions"
      className="multistream-instructions"
      aria-labelledby="songshake-feed-instructions-title"
      data-testid="multistream-instructions"
    >
      <h3 id="songshake-feed-instructions-title">{t('multistream.instructions.title')}</h3>
      <p>{t('multistream.instructions.intro')}</p>
      {streamKey && !revealed && (
        <p className="multistream-instructions-note">{t('multistream.instructions.keyHidden')}</p>
      )}
      <h4>{t('multistream.instructions.obs.title')}</h4>
      <ol data-testid="multistream-instructions-obs">{steps('obs', 5)}</ol>
      <h4>{t('multistream.instructions.restream.title')}</h4>
      <ol data-testid="multistream-instructions-restream">{steps('restream', 5)}</ol>
      <p className="multistream-instructions-note">{t('multistream.instructions.after')}</p>
    </section>
  );
}

export default MultistreamInstructions;
